import React from 'react';
import PropTypes from 'prop-types';
import Modal from './../_utils/modal';
import ProductImages from './product-images';

const ViewAllModal = ({
  open, thumbnails, onClose, ...props
}) => {
  if (!open) return null;

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        className='product-images'
        title={''}
        actions={
          <div>
            <button
              className="btn close-preview mt-0"
              onClick={onClose}>
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        }
      >
        <div>
          <ProductImages {...props} modal={true} />
        </div>
      </Modal>
    </>
  )
}
ViewAllModal.propTypes = {
  open: PropTypes.bool,
  thumbnails: PropTypes.array
};

ViewAllModal.defaultProps = {
  open: false,
  thumbnails: []
}

export default ViewAllModal;
